export const isEmpty = (item = null) => {
    if (!item) return true;
    return !Object.keys(item).length;
};
